<template>
  <div>
    <span v-if="title">{{ title }}</span>
    <v-autocomplete
      :label="label"
      item-text="title"
      item-value="id"
      outlined
      clearable
      autofocusx
      hide-no-data
      auto-select-first
      :hide-selected="false"
      :items="citiesFiltered"
      :search-input.sync="searchCity"
      :error-messages="errors"
      :loading="$apollo.queries.cities.loading || loading"
      :disabled="loading"
      v-model="cityId"
      @input:append="$emit('change', $event)"
    />
  </div>
</template>

<script>
import citiesQuery from '@/services/gql/types/City/queries/citiesGrid.gql'
export default {
  name: 'CityPicker',
  props: {
    value: {
      type: Number,
      default: null
    },
    errors: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    editOnly: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchCity: null,
      cities: []
    }
  },
  computed: {
    cityId: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    citiesFiltered () {
      if (this.searchCity === null) return this.cities
      return this.cities
        .filter(item => item.title.toLowerCase().indexOf(this.searchCity.toLowerCase()) !== -1)
    },
    selectedCity () {
      if (!this.value) return null
      return this.cities.find(item => item.id === this.value)
    }
  },
  apollo: {
    cities: {
      fetchPolicy: 'network-only',
      query: citiesQuery,
      pollInterval: 30000,
      variables: {
        where: {
          status_not: 'DRAFT'
        }
      },
      manual: true,
      result (res) {
        this.cities = res.data.cities.list
      }
    }
  }
}
</script>
